import { connectEditor } from '../../campaign-editor/connect-editor';
import ChangeRuntimeForm from './ChangeRuntimeForm';

export default connectEditor(({ campaignLinesById }) => ({
  campaignLinesById,
}))(ChangeRuntimeForm);
